module.exports = __webpack_public_path__ + "assets/1eeb3af2ba3d03023e2d66a5c193a190.mp3";